import {
  JSResource,
  type SimpleEntryPoint,
} from "@loop-payments/react-router-relay";
import type { Todos } from "./Todos";
import TodosQueryNode, {
  type TodosQuery$variables,
} from "./__generated__/TodosQuery.graphql";
import { parseTodoConnectionFilters } from "../model/TodoConnectionSerialization";
import { defaultFilters } from "../components/TodoListDefaultFilters";

const entryPoint: SimpleEntryPoint<typeof Todos> = {
  root: JSResource("Todos", () =>
    import("./Todos").then((module) => module.Todos),
  ),
  getPreloadProps({ request }) {
    const url = new URL(request.url);
    const variables: TodosQuery$variables = parseTodoConnectionFilters(
      url.search,
      defaultFilters,
    );

    return {
      queries: {
        query: {
          parameters: TodosQueryNode,
          variables,
          options: {
            fetchPolicy: "store-and-network",
          },
        },
      },
    };
  },
};

export default entryPoint;
